import {
  useGetApplicableBudgets,
  useGetBudgets,
} from '@/common/integrations/menhir/employee/budgets/budgets.hooks';
import { useGetFeatures } from '@/common/integrations/menhir/employee/features/features.hooks';
import { shouldTreatAsExpired } from '@/web/containers/Budgets/util';

export function useGetBudgetsByType(showExpired: boolean) {
  const {
    features: { FF_BUDGET_WITH_APPLICATION },
  } = useGetFeatures();

  const { budgets = [], isInitialLoading: isLoadingBudgets } = useGetBudgets();
  const {
    applicableBudgets = [],
    isInitialLoading: isLoadingApplicableBudgets,
  } = useGetApplicableBudgets({
    enabled: FF_BUDGET_WITH_APPLICATION,
  });

  if (isLoadingBudgets || isLoadingApplicableBudgets) {
    return {
      isLoading: true,
      activeBudgets: [],
      expiredBudgets: [],
      applicableBudgets: [],
      filteredBudgets: [],
    };
  }

  const active = budgets.filter(
    (budgetToFilter) => budgetToFilter.status === 'active'
  );
  const expired = budgets.filter(shouldTreatAsExpired);

  return {
    isLoading: false,
    activeBudgets: active,
    expiredBudgets: expired,
    applicableBudgets,
    filteredBudgets:
      showExpired || active.length === 0 ? [...active, ...expired] : active,
  };
}
